module.exports = __webpack_public_path__ + "img/digitalocean.acdee7f1.svg";